import { Layers } from 'lucide-react'
import type { RolloutPlan } from '@/types/patching'
import styles from './Patching.module.css'

/** Runner-side batch plan (informational — it is not a risk decision). */
export function RolloutPanel({ rollout }: { rollout: RolloutPlan | null | undefined }) {
  if (!rollout) return null
  const unsupported = rollout.unsupported_applications ?? []
  return (
    <section className={styles.section} aria-label="Rollout batches" data-testid="rollout-panel">
      <h3 className={styles.sectionTitle}>
        <Layers size={14} /> Rollout batches
      </h3>
      {rollout.batches.length === 0 ? (
        <p className={styles.muted}>No batches planned.</p>
      ) : (
        <ol className={styles.advisorList}>
          {rollout.batches.map((batch, index) => (
            <li key={index} data-testid="rollout-batch">
              <strong>Batch {index + 1}</strong>: <span className={styles.mono}>{batch.join(', ')}</span>
            </li>
          ))}
        </ol>
      )}
      {unsupported.length > 0 && (
        <div className={styles.legend} data-testid="rollout-unsupported">
          <strong>Applications without patch automation (unsupported — never counted compliant)</strong>
          <ul className={styles.advisorList}>
            {unsupported.map((app, i) => (
              <li key={`${i}-${app.application}`}>
                <span className={styles.mono}>{app.application}</span> ({app.mechanism}) — {app.reason}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  )
}
